<ui-card [uiBordered]="false" [uiHeadBorderless]="true" [uiRounded]="true" [uiTitle]="title" [uiExtra]="extraHeaderContentTemplate" [uiDescription]="'owned_by_me_and_my_teams' | localize">
  <ng-template #extraHeaderContentTemplate>
    <widget-actions [widgetId]="widgetId"></widget-actions>
  </ng-template>

  <assignee-active-okrs-list [trackMeta]="{ widget: 'my_okrs', name: 'home_customizable' }" [assigneeId]="currentUserId" assigneeType="user"></assignee-active-okrs-list>
</ui-card>
